/* eslint-disable no-nested-ternary */
import { Component } from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { Form, actions } from 'forms/rrf';
import { connect } from 'react-redux';
import Title from '../../common/page-title/index';
import FileTable from './csv-table';
import UploadHistory from './upload-history';
import { deleteImportableFiles, getDataImportIndex, importFiles, uploadFile } from '../../../actions/data-import';
import FileUpload from '../../common/form/elements/file-upload';

import './data-import.css';
import ArrowButton from '../../common/button-arrow';

const model = 'deep.admin_data_import';

class DataImport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkedList: [],
    };

    this.fileUpload = null;
  }

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;

    dispatch(getDataImportIndex());
  }

  handleListChange = (filename, type) => {
    let list = this.state.checkedList;

    switch (type) {
      case 'add': {
        list.push(filename);
        break;
      }
      case 'remove': {
        list = list.filter(item => item !== filename);
        break;
      }
      default:
        break;
    }

    this.setState({ checkedList: list });
  }

  handleUpload = (payload) => {
    const { dispatch } = this.props;

    dispatch(actions.submitFields(model, uploadFile(payload, dispatch))).then(() => {
      this.fileUpload.reset();
    });
  };

  handleImport = () => {
    const { dispatch } = this.props;
    const list = this.state.checkedList;

    this.setState({
      checkedList: [],
    });

    dispatch(importFiles(list));
  };

  handleDelete = () => {
    const { dispatch } = this.props;
    const { checkedList } = this.state;

    dispatch(deleteImportableFiles(checkedList));
  };

  renderFooter = () => {
    const { formValid, file } = this.props;
    const isFileSelected = typeof file === 'object';

    return (
      <div className="fluid text-right">
        <Form model={model} onSubmit={this.handleUpload}>
          <Row>
            <Col lg={7}></Col>
            <Col lg={5}>
              <FileUpload
                model={`${model}.file`}
                type={['text/csv', 'application/vnd.ms-excel']}
                ref={(instance) => {
                  this.fileUpload = instance;
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={2}>
              <Button
                className="btn red-ghost-btn mg-lr-10 text-uppercase"
                onClick={this.handleImport}
              >
                Import
              </Button>
              <Button
                className="btn red-ghost-btn mg-lr-10 text-uppercase"
                onClick={this.handleDelete}
              >
                Delete
              </Button>
            </Col>
            <Col lg={8}></Col>
            <Col lg={2}>
              <ArrowButton
                arrow={false}
                disabled={!formValid || !isFileSelected}
              >
                Upload
              </ArrowButton>
            </Col>
          </Row>
        </Form>
      </div>
    );
  };

  render() {
    const {
      fetched, files, history
    } = this.props;

    return (
      <div className="container-fluid">
        <Title>Data Import</Title>
        <Card>
          <Card.Body>
            {fetched ?
              <FileTable data={files} handleListChange={this.handleListChange}/> : (
                <div>
                  Loading...
                </div>
              )}
          </Card.Body>
          <Card.Footer>{this.renderFooter()}</Card.Footer>
        </Card>
        <h3>Upload History</h3>
        {fetched ? history.length === 0 ? (
          <Card><Card.Body>No import history in past 30 days.</Card.Body></Card>
          ) :
          <UploadHistory data={history}/> : (
            <Card>
              <Card.Body>
                Loading...
              </Card.Body>
            </Card>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  files: state.data_imports.files,
  history: state.data_imports.history,
  fetched: state.data_imports.fetched,
  formValid: state.deep.forms.admin_data_import.$form.valid,
  file: state.deep.forms.admin_data_import.file.value,
});

export default connect(mapStateToProps)(DataImport);
